import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoBoiler } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoBoiler} />; }
